import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

interface IBox {
  height?: string;
}

export const Box = styled.div<IBox>`
  padding: ${size(2)};

  height: ${({ height }) => (height && `${height}`) || 'auto'};

  &.bg {
    background: ${theme.colors.bg.accent};
  }

  &.bg-main {
    background: ${theme.colors.bg.main};
  }

  &.bg-highlight {
    background: ${theme.colors.bg.highlight};
  }

  &.bg-warning {
    background: ${theme.colors.bg.warning};
  }

  &.bg-member {
    background: ${theme.colors.bg.member};
  }
  &.bg-info {
    background: ${theme.colors.bg.info};
  }

  &.bg-success {
    background: ${theme.colors.bg.positive};
  }

  &.bg-error {
    background: ${theme.colors.bg.negative};
  }

  &.bg-productListing {
    background: ${theme.colors.bg.productListing};
  }

  &.border {
    border: 1px solid ${theme.colors.border.main};
  }

  &.rounded:not(.overhang) {
    border-radius: 4px;
  }

  &.rounded-x2:not(.overhang) {
    border-radius: 8px;
  }

  &.padding-none {
    padding: 0;
  }

  &.padding-1 {
    padding: ${size(1)};
  }

  &.padding-2 {
    padding: ${size(2)};
  }

  &.padding-3 {
    padding: ${size(3)};
  }

  &.padding-4 {
    padding: ${size(4)};
  }

  &.padding-5 {
    padding: ${size(5)};
  }

  &.padding-x {
    padding: 0 ${size(2)};
  }

  &.padding-y {
    padding: ${size(2)} 0;
  }
  &.slimFooter {
    min-height: 70vh;
    display: flex;
    flex-direction: column;
  }

  &.shrink {
    display: inline-block;
  }

  &.overhang {
    margin-left: -${theme.distances.containerGutterMd};
    margin-right: -${theme.distances.containerGutterMd};

    ${theme.screens.LtMd} {
      margin-left: -${theme.distances.containerGutter};
      margin-right: -${theme.distances.containerGutter};
    }
  }

  &.overhang-mobile {
    ${theme.screens.LtMd} {
      margin-left: -${theme.distances.containerGutter};
      margin-right: -${theme.distances.containerGutter};

      &.rounded,
      &.rounded-x2 {
        border-radius: 0;
      }
    }
  }

  &.overhang-desktop {
    ${theme.screens.Md} {
      margin-left: -${theme.distances.containerGutterMd};
      margin-right: -${theme.distances.containerGutterMd};

      &.rounded,
      &.rounded-x2 {
        border-radius: 0;
      }
    }
  }

  &.overhang-panel {
    margin-left: ${size(-3)};
    margin-right: ${size(-3)};
    padding-left: ${size(3)};
    padding-right: ${size(3)};

    ${theme.screens.Md} {
      margin-left: ${size(-5)};
      margin-right: ${size(-5)};
      padding-left: ${size(5)};
      padding-right: ${size(5)};
    }
  }

  &.border-top {
    border-top: 1px solid ${theme.colors.bg.outer};
  }

  & + &:not(.no-spacing) {
    margin-top: ${size(2)};
  }

  &.stretch {
    margin-left: ${size(-1)};
    margin-right: ${size(-1)};
  }
`;
